'use client';

import {
  CONTROL_RESPONSE,
  type ExperimentResponse,
  EvaluationContext,
  ExperimentService,
} from '@m/services/experimentation/ExperimentService';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { useEvaluationContext } from '@m/hooks/data/useEvaluationContext';

type ExperimentQueryOptions = Omit<
  UseQueryOptions<ExperimentResponse, Error>,
  'queryKey' | 'queryFn' | 'enabled'
>;

export const useExperiment = (
  experimentName: string,
  context?: EvaluationContext,
  enabled = true,
  queryOptions?: ExperimentQueryOptions,
) => {
  const evaluationContext = useEvaluationContext(context);

  return useQuery({
    ...queryOptions,
    queryKey: ['experiment', experimentName, evaluationContext],
    queryFn: async () => {
      try {
        return await ExperimentService.getExperiment(experimentName, evaluationContext);
      } catch {
        return CONTROL_RESPONSE(experimentName);
      }
    },
    enabled: !!experimentName && enabled,
  });
};
